// Copyright (c) 2025 Audere, All Rights Reserved

import type { SxProps, Theme } from "@mui/material";

export type StyleSheet = { [key: string]: SxProps<Theme> };

export const createStyleSheet = (styles: StyleSheet) => styles;

export const globalStyles = createStyleSheet({
  gapTop: {
    marginTop: 2,
  },
});
